// ============================================================================
// BINARY LIFT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'binary-lift',
  name: 'Binary Lifting',
  category: 'Data Structures',
  complexity: {
    time: 'O(N log N) preprocessing, O(log N) per query',
    space: 'O(N log N)'
  },
  description: 'A technique for answering ancestor queries and finding lowest common ancestors in trees efficiently. Precomputes 2^k-th ancestors for each node, enabling logarithmic-time queries using binary representation of distances.'
};
